import {
  Entity,
  Column,
  CreateDateColumn,
  UpdateDateColumn,
  ManyToOne,
  JoinColumn,
  PrimaryGeneratedColumn,
} from 'typeorm';

import { ClientStatus } from '../../interface/clients/clients-response.interface';
import { UsersEntity } from '../users/user.entity';
import { CompanyEntity } from '../companies/company.entity';

@Entity('clients')
export class ClientsEntity {

  @PrimaryGeneratedColumn('uuid')
  id!: string;

  @Column({ nullable: true })
  contact_person?: string;

  @Column({ nullable: true })
  designation?: string;

  @Column({ nullable: true })
  contact_number?: string;

  @Column({ nullable: true })
  email?: string;

  @Column({ type: 'varchar' })
  status!: ClientStatus;

  @CreateDateColumn()
  created_at!: Date;

  @UpdateDateColumn()
  updated_at!: Date;

  // RELATIONS

  @ManyToOne(() => UsersEntity, { nullable: true })
  @JoinColumn({ name: 'created_by_id' })
  created_by?: UsersEntity;

  @ManyToOne(() => UsersEntity, { nullable: true })
  @JoinColumn({ name: 'updated_by_id' })
  updated_by?: UsersEntity;

  // REQUIRED company relation
  @ManyToOne(() => CompanyEntity, { nullable: false })
  @JoinColumn({ name: 'company_id' })
  company!: CompanyEntity;
}